import { Component } from '@angular/core';
import { ListSubaccountsComponent } from '../../components/agency/subaccounts/list-subaccounts/list-subaccounts.component';
import { localStoragevarNames } from '../../utilities/local-storage-utils';
import { UserResponse } from '../../models/responses/user-response';
import { PaymentPlan } from '../../models/enums/payment-plan';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { pathNames, variablePathNames } from '../../utilities/routing-path-utils';
import { ConfigurePaymentPlansComponent } from '../../components/agency/subaccounts/configure-payment-plans/configure-payment-plans.component';
import { environment } from '../../environments/environments';


@Component({
  selector: 'app-subaccount-page',
  standalone: true,
  imports: [
    ListSubaccountsComponent,
    ConfigurePaymentPlansComponent,
    MatTabsModule,
    MatIconModule
  ],
  templateUrl: './subaccount-page.component.html',
  styleUrl: './subaccount-page.component.scss'
})
export class AgencyPageComponent {
  selectedIndex: number = 1;
  elementsToRender: string[] = ['subaccounts', 'rebilling'];
  constructor() { }
}
